/**
 * Unregister Service Worker & clear legacy browser storage
 *
 * Primärer Cleanup läuft früh inline in header.php (bevor Assets laden).
 * Dieses Modul ist nur Fallback, falls das Inline-Script nicht greift.
 *
 * @author jjarolim
 */

const CLEANUP_RELOAD_FLAG = 'legacy-sw-cleanup-reloaded'

const unregisterServiceWorkers = async () => {
    if (!('serviceWorker' in navigator)) {
        return false
    }

    const registrations = await navigator.serviceWorker.getRegistrations()
    if (!registrations.length) {
        return false
    }

    await Promise.all(registrations.map((registration) => registration.unregister()))
    return true
}

const clearCacheStorage = async () => {
    if (!('caches' in window)) {
        return false
    }

    const names = await caches.keys()
    if (!names.length) {
        return false
    }

    await Promise.all(names.map((name) => caches.delete(name)))
    return true
}

const clearWebStorages = () => {
    try {
        localStorage.clear()
    } catch (_) {
        // ignore (private mode / blocked storage)
    }

    try {
        sessionStorage.clear()
    } catch (_) {
        // ignore
    }
}

const init = () => {
    try {
        if (sessionStorage.getItem(CLEANUP_RELOAD_FLAG) || window.__legacySwCleanupStarted) {
            return
        }
        window.__legacySwCleanupStarted = true
    } catch (_) {
        window.__legacySwCleanupStarted = true
    }

    Promise.all([unregisterServiceWorkers(), clearCacheStorage()])
        .then(([unregistered, cachesCleared]) => {
            if (!unregistered && !cachesCleared) {
                return
            }

            clearWebStorages()

            try {
                sessionStorage.setItem(CLEANUP_RELOAD_FLAG, '1')
            } catch (_) {
                // ignore
            }

            window.location.reload()
        })
        .catch(() => {
            // ignore
        })
}

export { init }
